import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import WordPressAppLayout from "./WordPressAppLayout";

export const WordPressAppContext = React.createContext({});
let params = new URL(document.location).searchParams;
const id = params.get("clientId");
const apiKey = params.get("apiKey");
const slug = params.get("server");
const initialPage = params.get("page");

const WordPress = () => {
  const [page, setPage] = useState(initialPage || "bitbute-ar-viewer");

  return (
    <WordPressAppContext.Provider
      value={{
        initialPage,
        page: page,
        slug,
        projectId: id,
        apiKey,
        setPage,
      }}
    >
      <WordPressAppLayout>
        <Outlet />
      </WordPressAppLayout>
    </WordPressAppContext.Provider>
  );
};

export default WordPress;
